import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ComponentRoleModel } from 'src/app/model/component-role.model';

@Injectable({
  providedIn: 'root'
})
export class ComponentRoleService {
  private url: string;

  constructor(private http: HttpClient) {
    this.url = environment.services_url;
  }

  getAll = () => {
    return this.http.get(`${this.url}/ComponentRole/List`)
      .pipe(map((resp: any) => resp));
  }

  getByComponent = (componentId: number) => {
    return this.http.get(`${this.url}/ComponentRole/ListByComponent/${componentId}`)
      .pipe(map((resp: any) => resp));
  }

  getByRole = (roleId: string) => {
    return this.http.get(`${this.url}/ComponentRole/ListByRole/${roleId}`)
      .pipe(map((resp: any) => resp));
  }

  save = (componentRole: ComponentRoleModel) => {
    return this.http.post(`${this.url}/ComponentRole/SaveUpdate`, componentRole)
      .pipe(map((resp: any) => resp));
  }

  delete = (componentId: number, roleId: string) => {
    return this.http.delete(`${this.url}/ComponentRole/Delete/${componentId}/${roleId}`)
      .pipe(map((resp: any) => resp));
  }
}
